import * as React from 'react';
import { Form } from 'antd';
import { FormComponentProps, ValidationRule } from 'antd/lib/form';
import { ColProps } from 'antd/lib/col';
import bindAllOfThis from "src/utils/BindThisHelper";

export interface FieldDecoratorProps extends FormComponentProps {
    // Required
    name: string;

    // Optional
    rules?: ValidationRule[];
    initialValue?: {};
    /** Mainly used for checkboxes */
    valuePropName?: string;
    /** This is a weird param. It is fired with the selected values in the dropdown. The return value is the array of selected values.
     *
     * If you aren't using an `<Upload>`, you should probably leave it alone. This can also be used for a "Select All/None" `<Option>` */
    getValueFromEvent?: (...e: any) => any;

    label?: React.ReactNode;
    labelCol?: ColProps;
    wrapperCol?: ColProps;

    visible?: boolean;

    // Kinda from React
    key?: React.Key;
}

class FieldDecorator extends React.Component<FieldDecoratorProps> {
    constructor(props: FieldDecoratorProps) {
        super(props);
        bindAllOfThis(this, FieldDecorator.prototype);
    }

    private defaultGetValueFromEvent(e: any) {
        if (!e || !e.target) {
            return e;
        }
        const { target } = e;
        return target.type === 'checkbox' ? target.checked : target.value;
    }

    render() {
        let children: React.ReactNode = this.props.children;
        let visible = this.props.visible != null ? this.props.visible : true;

        if (!visible) {
            return null;
        }

        // Some fun defaults that I have had to use can be found here: https://github.com/react-component/form#option-object
        let fieldDecorator = this.props.form.getFieldDecorator(this.props.name, {
            initialValue: this.props.initialValue == null ? undefined : this.props.initialValue,
            valuePropName: this.props.valuePropName || "value", // Default set in antd
            getValueFromEvent: this.props.getValueFromEvent || this.defaultGetValueFromEvent, // Default set in antd somewhere
            rules: this.props.rules == null || this.props.rules.length === 0 ? undefined : this.props.rules
        });

        if (Array.isArray(children)) {
            console.warn("Form Item children must be a single react component, not an array. Rendering first element");
            children = children[0];
        }

        return <Form.Item key={this.props.key} label={this.props.label} labelCol={this.props.labelCol} wrapperCol={this.props.wrapperCol}>
            {fieldDecorator(this.props.children)}
        </Form.Item>;
    }

    // I have absolutely no idea what this is for
    public static DefaultGetValueFromEventForUpload(e: any) {
        if (Array.isArray(e)) {
            return e;
        }
        return e && e.fileList;
    }

    /**
     * Provides the standard 'Select All' event for the FieldDecorator's getValueFromEvent() function
     *
     * **This is designed for a `<Select>` component**
     *
     * @param {string} selectAllKey The key on the `<Select.Option>` for the Select All option
     * @param {((string | number)[])} allKeys The keys in the dropdown
     */
    public static StandardSelectAllEvent(selectAllKey: string, allKeys: (string | number)[]) {
        return (value) => {
            // 'all' comes from the 'All' value in the <Select.Option>
            if (value && value.length && value.includes(selectAllKey)) {
                // If all are selected, deselect everything
                if (value.length === allKeys.length + 1) {
                    return [];
                }

                let results = new Set<string | number>([...value, ...allKeys]);
                results.delete(selectAllKey);
                return Array.from(results);
            }
            return value;
        };
    }
}

export default FieldDecorator;



// WEBPACK FOOTER //
// ./src/components/common/form/FieldDecorator.tsx